import mutations from './mutations'
import {
  find,
  isEmpty
} from 'lodash'
// shared workbench properties
// TODO need to consider the dirty boolean value, I do not think it works 100%
// so that is why we are using the lastTimeSaved and getters.lastTimeTargetWasChanged
import {isActivationBlocked, isTargetOwnedBy} from '@/helpers'
import { convertViewingStreamForES } from '@/appLogic/targets/conversions'
export default {
  state: {
    metrics: null,
    quickAddAttributes: [],
    fetchingTarget: false,
    fetchingWorkbenchData: false,
    loading: false,
    saving: false,
    dirty: false,
    isDropped: false,
    streamingOption: 'aalivesd',
    lastTimeSaved: null,
    showTargetHistoryPanel: false,
    requestNumber: 0
  },
  getters: {
    streamingOption: (state, getters) => {
      if (getters.currentTarget.viewing_stream) {
        return convertViewingStreamForES(getters.currentTarget.viewing_stream)
      } else {
        return state.streamingOption ? state.streamingOption : 'aalivesd'
      }
    },
    metrics: state => state.metrics,
    loading: state => state.loading,
    targetName: (state, getters) => getters.currentTarget.display_name,
    quickAddAttributes: (state, getters) => state.quickAddAttributes.map(getters.getAttributeForIdDataset),
    isSaveEnabled: state => (state.dirty && !state.loading),
    isSaving: state => state.saving,
    isFetchingTarget: state => state.fetchingTarget,
    isFetchingWorkbenchData: state => state.fetchingWorkbenchData,
    // DEPRECATED
    isTargetActivated: (state, getters) => {
      if (isEmpty(getters.currentTarget)) return false
      return getters.currentTarget.activated
    },
    isTargetArchived: (state, getters) => {
      if (isEmpty(getters.currentTarget)) return false
      return getters.currentTarget.archived
    },
    // TODO change to targetDefinitionHasChangedSinceLastSave
    targetDefinitionHasChanged: (state, getters) => {
      const lastChange = getters.lastTimeTargetWasChanged
      const lastSaved = state.lastTimeSaved
      if (lastChange) {
        return lastSaved ? lastChange > lastSaved : true
      } else {
        return false
      }
    },
    targetInfo: (state, getters) => {
      let t = getters.currentTarget
      return {
        name: t.display_name,
        id: t.id,
        type: t.target
      }
    },
    startQ: state => state.dateRange ? (state.dateRange.startDate ? state.dateRange.startDate.name : '') : '',
    endQ: state => state.dateRange ? (state.dateRange.endDate ? state.dateRange.endDate.name : '') : '',
    getAttributeForIdDataset: state => {
      return ({id, dataset}) => {
        const dataSource = find(state.dataSources, {data: {id: dataset}})
        function findRecursive (dataSource) {
          for (let i = 0; i < dataSource.length; i++) {
            if (dataSource[i].id === id) return dataSource[i]
            if (dataSource[i].children) {
              const found = findRecursive(dataSource[i].children)
              if (found) return found
            }
          }

          return false
        }

        return findRecursive(dataSource.data.children)
      }
    },
    universeData: state => {
      return state.universe
    },
    viewershipData: state => {
      return state.historicalViewership
    },
    showGenerateEstimate: (state, getters) => {
      let target = getters.currentTarget
      if (target.display_name) {
        let activationBlocked = isActivationBlocked(target.target)
        let cantShow = target.activated || !isTargetOwnedBy(target, getters.username) || activationBlocked
        return !cantShow
      } else {
        return false
      }
    }
  },
  mutations
}



// WEBPACK FOOTER //
// ./src/app/views/workbenchCanvas/store/index.js